/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatisticsResponse
 */
export interface StatisticsResponse {
    /**
     * 
     * @type {number}
     * @memberof StatisticsResponse
     */
    rating: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsResponse
     */
    missionsCount: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsResponse
     */
    recommendationsCount: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticsResponse
     */
    appraisalsWithRatesCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof StatisticsResponse
     */
    invalidatedCharter: boolean;
}

/**
 * Check if a given object implements the StatisticsResponse interface.
 */
export function instanceOfStatisticsResponse(value: object): value is StatisticsResponse {
    if (!('rating' in value) || value['rating'] === undefined) return false;
    if (!('missionsCount' in value) || value['missionsCount'] === undefined) return false;
    if (!('recommendationsCount' in value) || value['recommendationsCount'] === undefined) return false;
    if (!('appraisalsWithRatesCount' in value) || value['appraisalsWithRatesCount'] === undefined) return false;
    if (!('invalidatedCharter' in value) || value['invalidatedCharter'] === undefined) return false;
    return true;
}

export function StatisticsResponseFromJSON(json: any): StatisticsResponse {
    return StatisticsResponseFromJSONTyped(json, false);
}

export function StatisticsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatisticsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rating': json['rating'],
        'missionsCount': json['missionsCount'],
        'recommendationsCount': json['recommendationsCount'],
        'appraisalsWithRatesCount': json['appraisalsWithRatesCount'],
        'invalidatedCharter': json['invalidatedCharter'],
    };
}

export function StatisticsResponseToJSON(value?: StatisticsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'rating': value['rating'],
        'missionsCount': value['missionsCount'],
        'recommendationsCount': value['recommendationsCount'],
        'appraisalsWithRatesCount': value['appraisalsWithRatesCount'],
        'invalidatedCharter': value['invalidatedCharter'],
    };
}

